import { createFileRoute, redirect } from "@tanstack/react-router";

import { InviteStep } from "~/pages/onboard/steps/invite-step";
import { activeOrganization$ } from "~/stores/organizations";

/**
 * Post-catalog "invite your team" step. Org-level and datasource-agnostic, so
 * it's a flat route with no `$datasourceId` param.
 *
 * Accepts `"keyTables"` and `"invite"` so a navigation from
 * `/onboard/key-tables` after Continue isn't bounced during the brief window
 * before `setOrgOnboardingStep("invite")` resolves. The step is optional —
 * Continue advances to `boards`.
 */
export const Route = createFileRoute("/onboard/invite")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "keyTables" && org.onboarding !== "invite") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: InviteStep,
});
